const STORAGE_PREFIX = 'figmawya_course_quiz_v1';

export function progressStorageKey(courseId) {
    return `${STORAGE_PREFIX}_${courseId}`;
}

/**
 * @param {string|number} courseId
 * @returns {Record<string, { passed?: boolean, quizId?: number }>}
 */
export function loadCourseQuizProgress(courseId) {
    if (typeof window === 'undefined') return {};
    try {
        const raw = localStorage.getItem(progressStorageKey(courseId));
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return typeof parsed === 'object' && parsed !== null ? parsed : {};
    } catch {
        return {};
    }
}

/**
 * @param {string|number} courseId
 * @param {string} sectionKey
 * @param {{ passed: boolean, quizId: number }} payload
 */
export function saveSectionQuizResult(courseId, sectionKey, payload) {
    if (typeof window === 'undefined') return;
    try {
        const all = loadCourseQuizProgress(courseId);
        all[sectionKey] = {
            ...all[sectionKey],
            ...payload,
            updatedAt: Date.now(),
        };
        localStorage.setItem(progressStorageKey(courseId), JSON.stringify(all));
    } catch {
        /* ignore */
    }
}

export function getUserIdFromToken() {
    if (typeof window === 'undefined') return null;
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload?.data?.user?.id ?? payload?.sub ?? payload?.user_id ?? null;
    } catch {
        return null;
    }
}
